import { render } from "./BlastOff.vue?vue&type=template&id=0aca2cd2&ts=true"
import script from "./BlastOff.vue?vue&type=script&lang=ts"
export * from "./BlastOff.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__